import { useEffect, useState } from 'react'

interface AmbassadorTabsProps {
  tabs: readonly { readonly id: string; readonly tabName: string }[]
  activeTab: string
  onChange: (id: string) => void
}

export const AmbassadorTabs = ({
  tabs,
  activeTab,
  onChange,
}: AmbassadorTabsProps) => {
  const [headerHeight, setHeaderHeight] = useState(0)

  useEffect(() => {
    const header = document.querySelector('header[aria-label="Site header"]')
    if (!header) return

    // eslint-disable-next-line react-hooks/set-state-in-effect -- syncing React state to the measured DOM header height (external system), the case this rule's own guidance calls out as valid
    setHeaderHeight(header.getBoundingClientRect().height)

    const observer = new ResizeObserver((entries) => {
      const entry = entries[0]
      if (entry) {
        setHeaderHeight(entry.target.getBoundingClientRect().height)
      }
    })

    observer.observe(header)
    return () => observer.disconnect()
  }, [])

  return (
    <div 
      className='sticky z-10 w-full bg-white shadow-sm transition-all duration-300'
      style={{ top: headerHeight > 0 ? `${headerHeight}px` : undefined }}
    >
      <div className='flex w-full overflow-x-auto'>
        {tabs.map((tab) => {
          const isActive = tab.id === activeTab
          return (
            <button
              key={tab.id}
              onClick={() => onChange(tab.id)}
              className={`flex min-w-[300px] flex-1 items-center justify-center gap-2 border-b-4 py-5 font-criteria text-sm font-bold uppercase transition-colors md:text-[15px] ${
                isActive
                  ? 'border-[#D9FF00] bg-[#111111] text-[#D9FF00]'
                  : 'border-transparent bg-white text-[#111111] hover:bg-gray-50'
              }`}
            >
              {tab.tabName}
              <span className={isActive ? 'text-[#D9FF00]' : 'text-gray-300'}>
                <IconSVG />
              </span>
            </button>
          )
        })}
      </div>
    </div>
  )
}

const IconSVG = () => (
  <svg
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M7 7L17 17M17 17V7M17 17H7'
      stroke='currentColor'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
)
